import React, { useEffect } from 'react';

import { ApiErrors, useQuery } from '@betterment/js-runtime';

import FullPageLoader from '../../Shared/components/FullPageLoader';
import { locationReplace } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';

interface ExtendedApiErrors extends ApiErrors {
  base: string[];
}

function requiresSudoSession(error: ExtendedApiErrors) {
  return error && error.base && error.base.includes('sudo session required');
}

function generateReturnTo() {
  return encodeURIComponent(`${window.location.pathname}${window.location.search}${window.location.hash}`);
}

function generateExitTo(exitTo?: string) {
  const exitPath = exitTo ?? urlBuilder.getAppChecking.absolute();
  return encodeURIComponent(exitPath);
}

interface Props {
  exitTo?: string;
}

const SudoRouteComponent: React.FC<React.PropsWithChildren<Props>> = ({ children, exitTo }) => {
  const { loading, errors, meta } = useQuery(urlBuilder.getSudoCheck());

  const extendedApiErrors = errors as ExtendedApiErrors;
  const sudoPath = meta?.sudoChallengesPath;

  useEffect(() => {
    if (requiresSudoSession(extendedApiErrors)) {
      locationReplace(`${sudoPath || ''}?return_to=${generateReturnTo()}&exit_to=${generateExitTo(exitTo)}`);
    }
  }, [extendedApiErrors, exitTo, sudoPath]);

  if (loading) {
    return <FullPageLoader />;
  }

  if (extendedApiErrors) {
    if (requiresSudoSession(extendedApiErrors)) {
      return <FullPageLoader />;
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw extendedApiErrors;
  }
  return children as React.ReactElement;
};

export default SudoRouteComponent;
